import { FunctionComponent, h, render, Fragment } from 'preact';
import { useContext, useEffect, useRef, useState } from 'preact/hooks';
import { getApi } from '../../../src/ts/libs/getApi';
import { getQueryString, createQueryString, filterQueryString } from '../../../src/ts/libs/queryStrings';
import { useFetch } from '../hooks/useFetch';
import { currency } from '../../../src/ts/libs/currency';
import { Invoices, SalesInvoicesOrdCreditNote, SearchInvoiceData, SearchInvoiceProps } from '../context/Invoices';
import { InfoBlock } from '../product-list-wrap/product-list-wrap';
import { LoadMore } from '../common/LoadMore';
import { Alert } from '../common/Alert';

const LoaderCard = () => <div class="product-row-loader"> </div>;

const StatementFilters = () => {
  const { search, handleFreshSearch } = useContext(Invoices);

  const handleChangeActive = (e: Event, data) => {
    e.preventDefault();
    handleFreshSearch(data);
  };
  const handleChangeMonths = (e) => {
    e.preventDefault();
    handleFreshSearch({ months: +e.target.value });
  };
  return (
    <div className="band band--muted">
      <div className="band__inner">
        <div className="band__content">
          <div className="your-statements-controls">
            <div className="nav-links nav-links__trade" id="invoice-type-nav">
              <ul className="nav-links__items">
                <li className={`nav-links__item  ${search.type === 'BOTH' ? 'nav-links__item--active' : ''}`}>
                  <a
                    href="#"
                    className="nav-links__item__action"
                    onClick={(e) => handleChangeActive(e, { type: 'BOTH' })}
                  >
                    Show all
                  </a>
                </li>
                <li className={`nav-links__item  ${search.type === 'INVOICES' ? 'nav-links__item--active' : ''}`}>
                  <a
                    href="#"
                    className="nav-links__item__action"
                    onClick={(e) => handleChangeActive(e, { type: 'INVOICES' })}
                  >
                    Invoices
                  </a>
                </li>
                <li className={`nav-links__item  ${search.type === 'CREDITS' ? 'nav-links__item--active' : ''}`}>
                  <a
                    href="#"
                    className="nav-links__item__action"
                    onClick={(e) => handleChangeActive(e, { type: 'CREDITS' })}
                  >
                    Credit
                  </a>
                </li>
              </ul>
            </div>
            <div className="form-field form-field__label-inline  ">
              <label className="form-field__label" htmlFor="invoicesFrom">
                Invoices from
              </label>
              <select name="months" id="invoicesFrom" className="select" onChange={handleChangeMonths}>
                <option selected={search.months === -1} value={-1}>
                  All
                </option>
                <option selected={search.months === 3} value={3}>
                  Last 3 months
                </option>
                <option selected={search.months === 6} value={6}>
                  Last 6 months
                </option>
                <option selected={search.months === 12} value={12}>
                  Last 12 months
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PaymentSummary = () => {
  const { selectedInvoices, selectedCredits } = useContext(Invoices);
  console.log({ selectedInvoices, selectedCredits });
  // total invoice amount
  const totalInvoiceAmount = selectedInvoices.reduce((acc, invoice) => acc + invoice.value, 0);
  // Total credit amount
  const totalCreditAmount = selectedCredits.reduce((acc, credit) => acc + Math.abs(credit.value), 0);

  // Total amount to pay
  const totalAmountToPay = totalInvoiceAmount - totalCreditAmount;

  return (
    <div className="band band--muted pay-selected band--tight    ">
      <div className="band__inner">
        <div className="band__content">
          <Alert message="Payments may take up to 2 working days to show on your account" />
          <div className="panel statement-heading ">
            <div className="statement-heading__details">
              <p>
                <strong>Selected Invoices</strong>
                <span>{totalInvoiceAmount > 0 ? currency(totalInvoiceAmount) : '£-'}</span>
              </p>
              <p>
                <strong>Selected credit</strong>
                <span>{totalCreditAmount > 0 ? currency(totalCreditAmount) : '£-'}</span>
              </p>
              <p>
                <strong>Total to Pay</strong>
                <span>{totalAmountToPay > 0 ? currency(totalAmountToPay) : '£-'}</span>
              </p>
            </div>
            <button
              type="submit"
              className="button button--wide statement-heading__action"
              id="pay-invoice-action"
              disabled={totalAmountToPay <= 0}
            >
              <span className="button__label  ">Pay all selected</span>
            </button>
            <input type="hidden" name="balance" id="pay-invoice-balance" />
          </div>
        </div>
      </div>
    </div>
  );
};

interface InvoiceRowProps {
  item: SalesInvoicesOrdCreditNote;
  type: 'invoice' | 'credit';
}

const InvoiceRow: FunctionComponent<InvoiceRowProps> = ({ item, type }) => {
  const { selectedInvoices, setSelectedInvoices, setSelectedCredits, selectedCredits } = useContext(Invoices);
  const isSelected =
    type === 'invoice'
      ? selectedInvoices.some((slected) => slected.id === item.Number)
      : selectedCredits.some((slected) => slected.id === item.Number);
  const handleToggleCheckbox = (e) => {
    const checked = e.target.checked;

    // if check box checked add to selected invoices array
    if (checked) {
      if (type === 'invoice') {
        setSelectedInvoices([...selectedInvoices, { id: item.Number, value: item.SalesLedgerEntry.Unallocated }]);
      } else {
        setSelectedCredits([...selectedCredits, { id: item.Number, value: item.SalesLedgerEntry.Unallocated }]);
      }
    } else {
      // Else remove from selected invoices array
      if (type === 'invoice') {
        setSelectedInvoices(selectedInvoices.filter((invoice) => invoice.id !== item.Number));
      } else {
        setSelectedCredits(selectedCredits.filter((credit) => credit.id !== item.Number));
      }
    }
  };

  const downloadLink = `/umbraco/Surface/DownloadDocumentSurface/DownloadDocument?documentId=${
    item.ID
  }&documentType=SL_${type === 'credit' ? 'CREDITNOTE' : 'INVOICE'}_STANDARD_P`;
  return (
    <div
      className={`trade-account-statement-table__row ${
        isSelected ? 'trade-account-statement-table__row--selected' : ''
      }`}
    >
      <div className="row__checkbox">
        <div className="checkbox   ">
          <input
            name="InvoiceIds"
            id={item.Number}
            value={item.Number}
            type="checkbox"
            checked={isSelected}
            onChange={handleToggleCheckbox}
          />
          <label htmlFor={item.Number} />
        </div>
      </div>
      <div className="row__invoice-id">
        <strong>{item.Number}</strong>
      </div>
      <div className="row__ref-no">
        <span>Ref No.</span>
        {item?.AlternateReference}
      </div>
      <div className="row__invoice-date">
        <span>Order date:</span>
        {item.Date}
      </div>
      <div className="row__due-date">
        <span>Due date:</span>
        {item.DueDate}
      </div>
      <div className="row__type">
        <span>Type:</span>
        {type.toUpperCase()}
      </div>
      <div className="row__total">
        <span>Total:</span>
        {currency(item.GrossAmount)}
      </div>
      <div className="row__outstanding">
        <span>Balance:</span>
        {currency(item.SalesLedgerEntry.Unallocated)}
      </div>
      <div className="row__action">
        <a href={downloadLink} className="button button--outline button--sm">
          <span className="button__label  ">Download</span>
        </a>
      </div>
    </div>
  );
};

const InvoiceList = ({ form }) => {
  const firstLoad = useRef(true);
  const allowed = ['page', 'type', 'months'];
  const searchRaw = window.location.search ? getQueryString(window.location.search) : {};

  const filteredSearch: any = filterQueryString(searchRaw, allowed);
  const baseSearch = {
    page: 1,
    limit: 8,
    type: 'BOTH',
    months: 12,
    ...filteredSearch,
  };
  const [items, setItems] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [selectedCredits, setSelectedCredits] = useState([]);
  const [search, setSearch] = useState<SearchInvoiceProps>(baseSearch);

  const { response, error, loading, fetchData, called } = useFetch<SearchInvoiceData>(
    `${getApi('myInvoicesAndCredits')}`,
    {}
  );

  const handleUpdateMerged = (data) => {
    setItems([...items, ...data.StatementItems]);
  };
  const handleUpdate = (data) => {
    setItems(data.StatementItems);
  };
  useEffect(() => {
    (async () => {
      const firstLoadResponse = await fetchData({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          ...search,
          page: 1,
          limit: firstLoad.current && +filteredSearch.page > 1 ? 8 * +filteredSearch.page : 8,
        }),
      });
      firstLoad.current = false;
      handleUpdate(firstLoadResponse.data);
    })();
  }, []);

  useEffect(() => {
    const newQueryString = createQueryString(filterQueryString(search, allowed));

    if (JSON.stringify(search) !== JSON.stringify(baseSearch)) {
      history.pushState(null, null, `?${newQueryString}`);
    }
  }, [search]);

  const handleFreshSearch = async (searchdata: Partial<SearchInvoiceProps>) => {
    handleUpdate([]);
    const newSearch = { ...search, ...searchdata, page: 1 };
    setSearch(newSearch);

    const fullUpdate = await fetchData({
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(newSearch),
    });

    handleUpdate(fullUpdate.data);

    return fullUpdate;
  };

  const handleGetMore = async (e) => {
    e.preventDefault();
    const newSearch = { ...search, page: +search.page + 1 };

    setSearch(newSearch);

    const pageUpate = await fetchData({
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(newSearch),
    });

    handleUpdateMerged(pageUpate.data);

    return pageUpate;
  };

  const handleToggleAllCheckbox = (e) => {
    const checked = e.target.checked;

    // if checked add all invoices to selected invoices array
    // and all credits to selected credits array
    if (items && items.length >= 1 && checked) {
      setSelectedInvoices(
        items
          .filter((item) => item.SalesInvoices)
          .map((item) => ({ id: item.SalesInvoices.Number, value: item.SalesInvoices.SalesLedgerEntry.Unallocated }))
      );
      setSelectedCredits(
        items
          .filter((item) => item.SalesCreditNotes)
          .map((item) => ({
            id: item.SalesCreditNotes.Number,
            value: item.SalesCreditNotes.SalesLedgerEntry.Unallocated,
          }))
      );
    } else {
      // else empty selected invoices array and selected credits array
      setSelectedInvoices([]);
      setSelectedCredits([]);
    }
  };

  const selectedCount = selectedInvoices.length + selectedCredits.length;
  return (
    <Invoices.Provider
      value={{
        items,
        setItems,
        search,
        setSearch,
        selectedInvoices,
        setSelectedInvoices,
        selectedCredits,
        setSelectedCredits,
        handleFreshSearch,
        form,
      }}
    >
      <StatementFilters />
      <PaymentSummary />
      <div className="band band--muted band--tight">
        <div className="band__inner">
          <div className="band__content">
            <div className="panel">
              <div className="trade-account-statement-table">
                <div className="trade-account-statement-table__header">
                  <div className="trade-account-statement-table__header__check">
                    <div className="checkbox">
                      <input
                        id="check-all"
                        name="check-all"
                        value="all"
                        type="checkbox"
                        checked={items && selectedCount === items.length}
                        onChange={handleToggleAllCheckbox}
                      />
                      <label htmlFor="check-all" />
                    </div>
                  </div>
                  <div>INV / CN No.</div>
                  <div>Reference No.</div>
                  <div>Invoice Date</div>
                  <div>Due Date</div>
                  <div>Type</div>
                  <div>Total</div>
                  <div>Outstanding</div>
                  <div />
                </div>
                <div className="trade-account-statement-table__rows">
                  {items?.map((item, i) => (
                    <InvoiceRow
                      key={i}
                      item={item.SalesInvoices || item.SalesCreditNotes}
                      type={item.SalesInvoices ? 'invoice' : 'credit'}
                    />
                  ))}
                  {loading && [...Array(2)].map((_, index) => <LoaderCard key={`loader${index}`} />)}

                  {called && !loading && error && (
                    <InfoBlock message="Sorry there was an error loading the product results" error />
                  )}

                  {called && !loading && !error && response?.StatementItems?.length === 0 && (
                    <InfoBlock>
                      <Fragment>
                        You have no open orders in your search range, view your{' '}
                        <a href="/account-dashboard/my-orders">Order History</a> to see completed orders
                      </Fragment>
                    </InfoBlock>
                  )}
                </div>
              </div>
            </div>
            <LoadMore count={items?.length || 0} response={response} handleGetMore={handleGetMore} loading={loading} />
          </div>
        </div>
      </div>
      {/* 
      <pre>
        <code>{JSON.stringify(selectedInvoices, null, 2)}</code>
        <code>{JSON.stringify(selectedCredits, null, 2)}</code>
        <code>{JSON.stringify(response, null, 2)}</code>
      </pre> */}
    </Invoices.Provider>
  );
};

try {
  const domContainer = document.querySelector('#my-invoices');
  const form = document.querySelector('#my-statements-form');
  if (domContainer) {
    const InvoiceListInner = domContainer.querySelector('.my-invoices');
    render(<InvoiceList form={form} />, domContainer, InvoiceListInner);
  }
} catch (e) {
  console.warn(e);
}
